import {
  agentDisplayAssociations,
  getGitRepoAttachment,
  type AgentAssociationRef,
} from '@reflex/shared';
import type { Agent } from '@/lib/types';

export interface AgentMetaLineProps {
  /**
   * The agent the line describes. Only the group chip needs it (removing this
   * agent from a group is one of its actions); everything else is derived
   * display data.
   */
  agentId?: string;
  agentType: string;
  model?: string | null;
  repoSlug?: string | null;
  branch?: string | null;
  /**
   * Linked work items to badge on the row, in display order (PRs first,
   * then Linear / Jira issues) — the output of `agentDisplayAssociations`.
   */
  associations?: AgentAssociationRef[];
}

export function agentToMetaLineProps(agent: Agent): AgentMetaLineProps {
  const repo = getGitRepoAttachment(agent);
  return {
    agentId: agent.id,
    agentType: agent.agentType,
    model: agent.model,
    repoSlug: repo?.repoSlug,
    branch: repo?.repoBranch,
    associations: agentDisplayAssociations(agent),
  };
}
